import React from 'react'
import Loader from 'react-loader-spinner'
import NotificationIcon from 'react-icons/lib/fa/bullhorn'
import {Button, Label, ListGroup, ListGroupItem} from 'reactstrap'
import {AvFeedback, AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation'
import '../../stylesheets/Users.css'

const modelFromUser = (user) => {
    return {
        notifyOnPowerOnOff: user.notifyOnPowerOnOff,
        notifyOnStartStop: user.notifyOnStartStop,
        notifyOnAlarmStop: user.notifyOnAlarmStop,
        notifyOnConnectionLoss: user.notifyOnConnectionLoss,
        notifyOnLowTank: user.notifyOnLowTank,
        notifyOnFlowIssue: user.notifyOnFlowIssue,
        notifyOnCommand: user.notifyOnCommand,
        PHONEnotifications: user.PHONEnotifications,
        EMAILnotifications: user.EMAILnotifications,
        JDOnotifications: user.JDOnotifications,
        phone: user.phone
    }
}

const filterTeamsForID = (teams, id) => {
    if (teams && teams.length && teams.length > 0 && id) {
        return teams.filter(t => t.id === id)
    } else {
        return []
    }
}

const switchToTeam = (history) => (event) => {
    let team = event.target.value
    history.push(`${history.location.pathname}?tab=2&team=${team}`)
}

let NotificationPreferencesForm = ({loading, onValidSubmit, onInvalidSubmit, user, activeTeam, teams, history, integration}) => {
    let matchingTeams = filterTeamsForID(teams, activeTeam)

    return <div className="p-0 m-0">
                <h2 className="mb-4 text-center form-head">
                    <NotificationIcon className="light-sf-blue"/> Notify Me for
                    {teams && teams.length > 1 ?
                        <select key={`team-select-${activeTeam}-${teams.length}`}
                                 defaultValue={activeTeam}
                                 onChange={switchToTeam(history)}
                                 className="ml-2 mr-2 notification-team-selector">
                            {teams.map((t, idx) =>
                                <option key={`team-option-${t.id}-${idx}`} value={`${t.id}`}>{t.name}</option>
                            )}
                        </select> :
                        (matchingTeams.length > 0 ?
                            <span className="light-sf-blue">
                                &ensp;{matchingTeams[0].name}&ensp;
                            </span> :
                            <span className="light-sf-blue">
                                &emsp;...&emsp;
                            </span>)}
                    When
                </h2>
                {loading ?
                    <div className="w-100 h-100 text-center">
                        <Loader type="TailSpin" color="orange" width={60} height={60}/>
                    </div> :
                        <AvForm onValidSubmit={onValidSubmit} onInvalidSubmit={onInvalidSubmit} model={modelFromUser(user)}>
                            <ListGroup className="text-left mb-5 col-12 offset-0 pr-0 pl-0 col-sm-10 offset-sm-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
                                <ListGroupItem>
                                    <AvGroup check>
                                        <Label check>
                                            <AvInput type="checkbox" className="notification-preference" name="notifyOnPowerOnOff"/> When a Controller is Turned On or Off
                                        </Label>
                                    </AvGroup>
                                </ListGroupItem>
                                <ListGroupItem>
                                    <AvGroup check>
                                        <Label check>
                                            <AvInput type="checkbox" className="notification-preference" name="notifyOnStartStop"/> When a Pump is Started or Stopped by a Controller
                                        </Label>
                                    </AvGroup>
                                </ListGroupItem>
                                <ListGroupItem>
                                    <AvGroup check>
                                        <Label check>
                                            <AvInput type="checkbox" className="notification-preference" name="notifyOnAlarmStop"/> When a Pump Stops Due to a Controller Alarm
                                        </Label>
                                    </AvGroup>
                                </ListGroupItem>
                                <ListGroupItem>
                                    <AvGroup check>
                                        <Label check>
                                            <AvInput type="checkbox" className="notification-preference" name="notifyOnConnectionLoss"/> When a Controller Loses Connection
                                            Unexpectedly
                                        </Label>
                                    </AvGroup>
                                </ListGroupItem>
                                <ListGroupItem>
                                    <AvGroup check>
                                        <Label check>
                                            <AvInput type="checkbox" className="notification-preference" name="notifyOnLowTank"/> When a Controller Detects Low Tank Level
                                        </Label>
                                    </AvGroup>
                                </ListGroupItem>
                                <ListGroupItem>
                                    <AvGroup check>
                                        <Label check>
                                            <AvInput type="checkbox" className="notification-preference" name="notifyOnFlowIssue"/> When a Controller Detects a Flow Issue
                                        </Label>
                                    </AvGroup>
                                </ListGroupItem>
                                <ListGroupItem>
                                    <AvGroup check>
                                        <Label check>
                                            <AvInput type="checkbox" className="notification-preference" name="notifyOnCommand"/> When a Settings Change is Sent to a Controller
                                        </Label>
                                    </AvGroup>
                                </ListGroupItem>
                            </ListGroup>
                            <ListGroup className="text-left mb-5 col-12 offset-0 pr-0 pl-0 col-sm-10 offset-sm-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
                                <Label className="text-center">Notification Preferences for {matchingTeams.length > 0 ?
                                                <span>
                                                    
                                                    <strong>{matchingTeams[0].name}</strong>
                                                </span> :
                                                <strong>&emsp;...&emsp;</strong>}</Label>
                                <ListGroupItem>
                                    <AvGroup check>
                                        <Label check>
                                            <AvInput type="checkbox" className="notification-preference" name="PHONEnotifications"/> Receive Notifications by Text Message
                                        </Label>
                                        <AvField 
                                            name="phone"
                                            placeholder="Phone # 000-000-0000"
                                            className="col-10 offset-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 mt-1"
                                            errorMessage="Please enter a valid phone number with area code."
                                            validate={{
                                                myCustomValidation: (value, ctx) => {
                                                    if(ctx.PHONEnotifications && value.trim() === '') {
                                                        return 'Phone number is required when phone notifications are enabled.';
                                                    }
                                                    return true;
                                                }
                                            }}
                                        />
                                    </AvGroup>
                                </ListGroupItem>
                                <ListGroupItem>
                                    <AvGroup check>
                                        <Label check>
                                            <AvInput type="checkbox" className="notification-preference" name="EMAILnotifications"/> Receive Notifications by Email to: {user.email}
                                        </Label>
                                    </AvGroup>
                                </ListGroupItem>
                                {integration ? <ListGroupItem>
                                    <AvGroup check>
                                        <Label check>
                                            <AvInput type="checkbox" className="notification-preference" name="JDOnotifications"/> Receive Notifications through Operations Center Mobile App
                                        </Label>
                                    </AvGroup>
                                </ListGroupItem> : null}
                            </ListGroup>
                            
                            <AvGroup className="justify-content-center text-center">
                                <Button className="col-10 col-sm-7 col-lg-3">Save Notification Settings</Button>
                            </AvGroup>
                        </AvForm>}
    </div>
}

export default NotificationPreferencesForm



// WEBPACK FOOTER //
// ./src/components/ui/NotificationPreferencesForm.js